import { UpdateVoucherForm } from './update-voucher-form'

export const UpdateVoucherModalMainNZ = ({
  voucherId,
  onCloseModal,
}: {
  voucherId: number
  onCloseModal: () => void
}) => {
  return <UpdateVoucherForm voucherId={voucherId} onCloseModal={onCloseModal} />
}
